import { Actions } from "./actions";
import { IO_ERROR, ErrorAction } from "../../../ajax/state/actions";
import { State } from "../state/state";
import { Commands, Mask } from "../../../shared";
import { fromServer, toServer } from "../filters";
import initial from "./state.initial";
import { Utils } from "../../../utils";
import { ReducerActions, createReducerActions } from "../../../Store/reducer";

type Actions =
  | Actions.GetRequest
  | Actions.PostRequest
  | Actions.GetResponse
  | Actions.PostResponse
  | Actions.Edit
  | Actions.EditCommands
  | ErrorAction;

const actions: ReducerActions<State.Props, Actions> = {
  [Actions.REQUEST_GET]: getRequest,
  [Actions.REQUEST_POST]: postRequest,
  [Actions.RESPONSE_GET]: getResponse,
  [Actions.RESPONSE_POST]: postResponse,
  [Actions.RESPONSE_POST_END]: postResponseEnd,
  [Actions.EDIT]: edit,
  [Actions.EDIT_COMMANDS]: editCommands,
  [IO_ERROR]: error
};

export default createReducerActions(actions, initial);

/**
 * @brief Action [REQUEST_GET] reducer
 */
function getRequest(state: State.Props): State.Props {
  return { ...state, loadingGet: true };
}

/**
 * @brief Action [REQUEST_POST] Reducer
 */
function postRequest(state: State.Props, action: Actions.PostRequest) {
  action.post = {};
  // Loop inputs look for changes to submit to server
  for (let i = 0; i < state.form.length; i++) {
    let diff: Partial<State.Input> = {};
    let diffCmds: Commands<Mask> = {};
    // Loop through commands in each input and see if changes need to submit to
    // server
    for (let key in state.form[i].cmds) {
      let formMask = state.form[i].cmds[key].join("");
      let dataMask = state.data[i].cmds[key].join("");
      if (formMask !== dataMask) diffCmds[key] = state.form[i].cmds[key];
    }
    // Submit changes
    if (state.form[i].id !== state.data[i].id) diff.id = state.form[i].id;
    if (Object.keys(diffCmds).length) diff.cmds = diffCmds;
    if (Object.keys(diff).length) action.post[`input${i}`] = toServer(diff);
  }
  return { ...state, loadingPost: true };
}

/**
 * @brief Action [RESPONSE_GET] Reducer
 */
function getResponse(
  state: State.Props,
  action: Actions.GetResponse
): State.Props {
  let inputs: State.Input[] = [];
  for (let key in action.data.inputs) {
    inputs.push(fromServer(action.data.inputs[key]));
  }
  return {
    ...state,
    status: "OK",
    data: Object.assign([], inputs),
    form: Object.assign([], inputs),
    submitRequired: false,
    loadingGet: false
  };
}

/**
 * @brief Action [RESPONSE_POST] Reducer
 */
function postResponse(state: State.Props): State.Props {
  return { ...state };
}

/**
 * @breif Action [RESPONSE_POST_END] Reducer
 */
function postResponseEnd(state: State.Props): State.Props {
  return { ...state, loadingPost: false };
}

/**
 * @brief Action [EDIT] Reducer
 */
function edit(state: State.Props, action: Actions.Edit): State.Props {
  const edit = Object.assign({}, state.form[action.idx], action.data);
  let form: State.Data = Object.assign([], state.form, {
    [action.idx]: edit
  });
  let submitRequired = false;
  for (let idx in form) {
    if (Utils.isDiff({ id: form[idx].id }, { id: state.data[idx].id })) {
      submitRequired = true;
    }
  }
  return { ...state, ...{ form }, submitRequired };
}

/**
 * @brief Merge new mask property into existing mask property for the selected
 * input
 */
function editCommands(
  state: State.Props,
  action: Actions.EditCommands
): State.Props {
  const { url, idx, output, cmd } = action;
  const oldCmds = state.form[idx].cmds;
  const editCmds = Object.assign({}, oldCmds, {
    [url]: Object.assign([], oldCmds[url], { [output]: cmd })
  });
  const edit = Object.assign({}, state.form[idx], { cmds: editCmds });
  let form: State.Data = Object.assign([], state.form, { [idx]: edit });
  let submitRequired = false;
  for (let idx in form) {
    for (let url in form[idx].cmds) {
      let cmd = form[idx].cmds[url].join("");
      if (!(cmd == state.data[idx].cmds[url].join(""))) submitRequired = true;
    }
  }
  return {
    ...state,
    form,
    submitRequired
  };
}

function error(state: State.Props): State.Props {
  return { ...state, loadingPost: false, loadingGet: false };
}
